import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Droplets, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email.trim(), password);
      navigate(user.role === "admin" ? "/admin" : from, { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-4 py-12" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary text-white">
            <Droplets className="h-6 w-6" />
          </span>
          <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Bine ai revenit</h1>
          <p className="mt-1 text-sm text-slate-500">Autentifică-te în contul ClarWash</p>
        </div>
        <form onSubmit={submit} className="space-y-4 rounded-2xl border border-slate-200 bg-white p-8">
          {error && <div className="rounded-lg bg-destructive/10 px-4 py-2 text-sm text-destructive" data-testid="login-error">{error}</div>}
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="login-email" autoCapitalize="none" autoCorrect="off" spellCheck={false} required />
          </div>
          <div>
            <Label htmlFor="password">Parolă</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="login-password" required />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full hover:bg-primary/90" data-testid="login-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Autentificare"}
          </Button>
          <p className="text-center text-sm text-slate-500">
            Nu ai cont? <Link to="/inregistrare" className="font-medium text-primary hover:underline">Creează cont</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
